import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "";

function StatusBadge({ status }) {
  return <span className={`badge badge-${status}`}>{status}</span>;
}

export default function Matches() {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/api/matches?limit=30`)
      .then((r) => setMatches(r.data.matches || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1>📋 Recent Matches</h1>
      <div className="card">
        {loading ? (
          <p style={{ color: "#9ca3af" }}>Loading...</p>
        ) : matches.length === 0 ? (
          <p style={{ color: "#9ca3af" }}>No matches recorded yet.</p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Map</th>
                <th>Teams</th>
                <th>Score</th>
                <th>Status</th>
                <th>Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {matches.map((m) => (
                <tr key={m.id}>
                  <td style={{ fontWeight: "600" }}>{m.map}</td>
                  <td style={{ color: "#9ca3af", fontSize: "0.85rem" }}>
                    {m.team1_name || "Team 1"} vs {m.team2_name || "Team 2"}
                  </td>
                  <td>
                    <span style={{ color: "#f0a500", fontWeight: "700" }}>
                      {m.team1_score} – {m.team2_score}
                    </span>
                  </td>
                  <td>
                    <StatusBadge status={m.status} />
                  </td>
                  <td style={{ color: "#9ca3af", fontSize: "0.85rem" }}>
                    {m.finished_at ? new Date(m.finished_at).toLocaleDateString() : "—"}
                  </td>
                  <td>
                    <Link to={`/matches/${m.id}`} style={{ color: "#5865f2", fontSize: "0.85rem" }}>
                      View →
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
